import React, { useEffect, useState } from 'react';
import Spread from './spread';
import useChangeSymbol from '../../hooks/useChangeSymbol';
import { useAppDispatch } from '../../redux/app';

const List = ({ index, item, active }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const changeSymbol = useChangeSymbol(dispatch);

  useEffect(() => {
    setTimeout(() => {
      setLoading(active);
    }, 200);
  }, [active]);

  return (
    <div
      id={`items_transition`}
      key={index}
      onClick={() => {
        changeSymbol(item);
      }}
      style={{
        opacity: loading ? 1 : 0,
        transformOrigin: 'top',
        transform: loading
          ? 'perspective(75em) rotateX(360deg)'
          : 'perspective(26em) rotateX(300deg)',
        transition: loading ? `transform ${100 * index}ms ease-in-out` : 'none'
      }}
      className="dropdow-item flex items-center dropdown-item">
      <div className="flex w-100">
        <div className="flex flex-[0.65] items-center">
          <div>
            <img
              width="35px"
              height="35px"
              src={`https://storage.googleapis.com/iux-storage/symbol/${item.symbol}.png`}
              onError={({ currentTarget }) => {
                currentTarget.src = 'globe.svg';
              }}
              className="rounded-[50%]"
              alt="..."
            />
          </div>
          <div style={{ marginLeft: 25 }}>
            <div className="font-[600] text-[13px] text-neutral-200">{item.symbol}</div>
            <div className="text-[10px] font-[400] text-[#9f9f9f] line-clamp-1">
              {item.company_name}
            </div>
          </div>
        </div>
        <Spread item={{ symbol: item.symbol, digit: item.digit }} />
      </div>
    </div>
  );
};

export default List;
